import React, { Component } from "react";
import CustomizedSelect from "./customizedSelect";
import { Input } from "../../forms/input";
import Signbutton, { Debtbutton } from "../../forms/button";
import { connect } from "react-redux";
import {
  YES,
  PARTIAL,
  FULL,
  UNITS,
  AMOUNT,
  PURCHASE,
  REDEMPTION,
} from "../../../store/types";
import MenuItem from "@material-ui/core/MenuItem";
import {
  getBankDetails,
  getRedemptionPaymentDetails,
  saveTransactionDetails,
} from "../../../store/actions/transactions";
import moment from "moment";
import { NEW_TRANSACTION_URL } from ".";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { BajajFund } from "../nav";

class Redemption extends Component {
  constructor(props) {
    super(props);
    // const { fundList } = this.props;
    // const funds = fundList.reduce((prev, curr) => {
    //   if (curr.rSchFlg === YES) {
    //     const findIndex =
    //       prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
    //     if (!findIndex) {
    //       return [
    //         ...prev,
    //         { Fund: curr.Fund, FundDesc: curr.FundDesc, scheme: curr.Sch },
    //       ];
    //     }
    //   }
    //   return prev;
    // }, []);

    this.state = {
      // funds,
      fund: { value: { value: "189" } },
      folios: [],
      folio: { value: "" },
      schemes: [],
      scheme: { value: "" },
      bank: { value: "", errorMessage: "" },
      amount: { value: "" },
      redemptionType: PARTIAL,
      redemptionMode: UNITS,
      banks: [],
    };
  }
  async componentDidMount() {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
    const { transactionDetails } = this.props;
    if (Object.keys(transactionDetails).length > 0) {
      this.setState(transactionDetails);
      return;
    }
    this.getfolios();
  }

  getfolios = () => {
    const folios = this.props.fundList.reduce((prev, curr) => {
      if (curr.rSchFlg === YES && curr.Fund.trim() === "189") {
        return [...prev, curr.Acno];
      }
      return prev;
    }, []);
    this.setState({
      fund: { value: { value: "189" } },
      folios: Array.from(new Set(folios)),
      scheme: { value: "" },
      folio: { value: "" },
      redemptionType: PARTIAL,
      redemptionMode: UNITS,
    });
  };

  handleFundChange = (value) => {
    const fund = !!value ? value.value : "";
    if (!value) {
      this.setState({
        fund: { value: "" },
        folios: [],
        scheme: { value: "" },
        folio: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
        amount: { value: "" },
      });
      return;
    } else if (value.value === this.state.fund.value.value) {
      return;
    } else {
      const folios = this.props.fundList.reduce((prev, curr) => {
        if (curr.rSchFlg === YES && curr.Fund === fund) {
          return [...prev, curr.Acno];
        }
        return prev;
      }, []);
      this.setState({
        fund: { value },
        folios: Array.from(new Set(folios)),
        scheme: { value: "" },
        folio: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
      });
    }
  };
  handleFolioChange = async (value) => {
    const folio = !!value ? value.value : "";
    if (!folio) {
      this.setState({
        folio: { value: "" },
        scheme: { value: "" },
        schemes: [],
        banks: [],
        bank: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
        amount: { value: "" },
      });
    } else if (value.value === this.state.folio.value) {
      return;
    } else {
      const params = {
        Acno: folio,
        Trtype: "",
        Fund: this.state.fund.value.value,
      };
      let schemes = this.schemes(folio);
      schemes = schemes.filter((scheme) => scheme.BalUnits !== 0);
      const response = await this.props.getBankDetails(params);

      if (response) {
        const banks = response.Table1;
        this.setState({
          folio: {
            value,
            isError: !schemes.length,
            errorMessage: !schemes.length
              ? "Redemption in zero balance folios is not allowed"
              : "",
          },
          scheme: { value: "" },
          schemes,
          banks,
          bank: { value: "" },
          redemptionType: PARTIAL,
          redemptionMode: UNITS,
        });
      }
    }
  };

  schemes = (folio) => {
    return this.props.fundList.reduce((prev, curr) => {
      if (
        curr.rSchFlg === YES &&
        curr.Fund.trim() === "189" &&
        curr.Acno === folio &&
        !!curr.BalUnits
      ) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };
  handleSchemeChange = (value) => {
    const scheme = !!value ? value.value : "";
    if (!scheme) {
      this.setState({
        scheme: { value: "" },
        minAmount: "",
        amount: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
      });
    } else if (value.value === this.state.scheme.value.value) {
      return;
    } else {
      this.setState({
        scheme: { value },
        minAmount: !!scheme ? scheme.RedMinAmt || scheme.fm_newpur : "",
        amount: { value: "" },
        redemptionType: PARTIAL,
        redemptionMode: UNITS,
      });
    }
  };

  showError = (label) => () => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "amount") {
      if (!!this.state.scheme && !!this.state.scheme.value) {
        this.setState({
          [label]: {
            value,
            isError:
              this.state.redemptionMode === AMOUNT
                ? this.state.scheme.value.value.MinAmt > this.state.amount.value
                  ? true
                  : !value
                : this.state.scheme.value.value.BalUnits <
                  this.state.amount.value
                ? true
                : !value,
            errorMessage:
              this.state.redemptionMode === AMOUNT
                ? this.state.scheme.value.value.MinAmt > this.state.amount.value
                  ? `(Amount should be ${this.state.scheme.value.value.MinAmt})`
                  : ""
                : this.state.scheme.value.value.BalUnits <
                  this.state.amount.value
                ? `You don't have enough Units To Redeem!`
                : "",
          },
        });
      }
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };
  handleRedemptionValueChange(event) {
    if (event.target.value.length <= 10) {
      this.setState({
        amount: { value: event.target.value.replace(/^0+/, "") },
      });
    }
  }

  changeRedemptionType = (value) => () => {
    if (value === FULL) {
      this.setState({
        redemptionType: FULL,
        redemptionMode: UNITS,
        amount: {
          value: !!this.state.scheme.value
            ? this.state.scheme.value.value.BalUnits
            : "",
        },
      });
    }
    if (value === PARTIAL) {
      this.setState({
        redemptionType: PARTIAL,
        amount: { value: "" },
      });
    }
  };
  changeRedemptionMode = (value) => () => {
    if (value === AMOUNT) {
      this.setState({
        redemptionMode: AMOUNT,
        amount: { value: "" },
      });
    }
    if (value === UNITS) {
      this.setState({
        redemptionMode: UNITS,
      });
    }
  };
  handlefolioBankDetailsChange = (event) => {
    this.setState({
      bank: { value: event.target.value },
    });
  };

  submit = async () => {
    const {
      funds,
      banks,
      schemes,
      folios,
      redemptionType,
      redemptionMode,
      minAmount,
      bank,
      ...others
    } = this.state;
    if (this.state.bank.value === "") {
      this.setState({
        bank: {
          value: "",
          isError: true,
          errorMessage: "Bank details are mandatory",
        },
      });
    }
    let currValue;
    if (!!this.state.scheme.value) {
      currValue = !!this.state.scheme.value.value
        ? this.state.scheme.value.value.Fund_CurValue
        : "";
    }
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "folio"
                  ? "Folio"
                  : key === "scheme"
                  ? "Scheme"
                  : key === "amount"
                  ? "Redemption Value"
                  : key
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "folio": {
          this.folioField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "amount": {
          this.amountField.focus();
          break;
        }
        // case "bank": {
        //   this.bankField.focus();
        //   break;
        // }
      }
    } else if (
      this.state.redemptionMode === AMOUNT &&
      this.state.scheme.value.value.MinAmt > this.state.amount.value
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: `Minimum Amount shoud be ${this.state.scheme.value.value.MinAmt} ₹`,
        },
      });
    }
    // else if (
    //   !!currValue &&
    //   !!this.state.amount.value &&
    //   currValue < this.state.amount.value
    // ) {
    //   this.setState({
    //     amount: {
    //       value: "",
    //       isError: true,
    //       errorMessage:
    //         "( Investment amount should not be greater than Current value )"
    //     }
    //   });
    // }
    else if (
      !!this.state.scheme.value && !!this.state.amount.value && parseInt(this.state.scheme.value.value.CurValue.replace(/,/g, '')) < parseInt(this.state.amount.value)
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage:
            "( Investment amount should not be greater than Current value )"
        }
      });
      return;
    }

    else if (
      this.state.redemptionMode !== AMOUNT &&
      this.state.scheme.value.value.BalUnits < this.state.amount.value
    ) {
      this.setState({
        amount: {
          value: "",
          isError: true,
          errorMessage: `Please enter units less than or equal to your current holding`,
        },
      });
    } else if (this.state.bank.value === "") {
      this.setState({
        bank: {
          ...others["bank"],
          isError: true,
          errorMessage: `Please select the bank`,
        },
      });
    } else {
      const params = {
        amount: redemptionMode === AMOUNT ? others.amount.value : "0",
        Fund: "189",
        plan: others.scheme.value.value.Pln,
        customfund: "189",
        scheme: others.scheme.value.value.Sch,
        acno: others.scheme.value.value.Acno,
        trdt: moment(new Date()).format("MM/DD/YYYY"),
        units: redemptionMode === UNITS ? others.amount.value : "0",
        ttrtype: PURCHASE,
      };
      const response = await this.props.getRedemptionPaymentDetails(params);
      if (response) {
        this.props.saveTransactionDetails(this.state);
        this.props.history.push({
          pathname:
            NEW_TRANSACTION_URL + "/redemption/digital/transact/confirm",
          state: {
            title: "Redemption Summary",
            type: REDEMPTION,
            scheme: others.scheme.value.value,
            redemptionMode,
            Folio: { value: others.scheme.value.value.Acno },
            redemptionType,
            amount: others.amount.value,
            bank: this.state.bank.value,
          },
        });
      }
    }
  };

  render() {
    const {
      fund,
      funds = [],
      folio,
      folios = [],
      schemes = [],
      scheme,
      bank,
      banks,
      amount,
      redemptionType,
      redemptionMode,
    } = this.state;

    return (
      <div className="transaction-details">
        <div className="title">Redemption</div>
        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            isError={folio.isError}
            disabled={!fund.value}
            errorMessage={folio.errorMessage}
          />
        </div>

        <div className="input-name">
          <div className="input-name input-integrated-label">Scheme</div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
              value: item,
            }))}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            disabled={!folio.value}
            errorMessage={scheme.errorMessage}
          />
        </div>

        <div className="redemption-details">
          <div className="keys">
            <div>Balance Units</div>
            <div>Current Value</div>
            <div>NAV as on Date</div>
            <div>Minimum Amount (₹)</div>
          </div>
          <div className="values">
            <div>{!!scheme.value ? scheme.value.value.BalUnits : ""}</div>
            <div>{!!scheme.value ? scheme.value.value.CurValue : ""}</div>
            <div>{!!scheme.value ? scheme.value.value.LastNAV : ""}</div>
            <div>{!!scheme.value ? scheme.value.value.MinAmt : ""}</div>
          </div>
        </div>

        <div className="input-name">Redemption Type</div>
        <div className="radio-buttons-div">
          <Debtbutton
            buttontitle="Partial"
            width={150}
            active={redemptionType === PARTIAL}
            onClick={this.changeRedemptionType(PARTIAL)}
          />
          <Debtbutton
            buttontitle="Full"
            width={150}
            active={redemptionType === FULL}
            onClick={this.changeRedemptionType(FULL)}
          />
        </div>

        <div className="input-name">Redemption Mode</div>
        <div className="radio-buttons-div">
          <Debtbutton
            buttontitle="Units"
            width={150}
            active={redemptionMode === UNITS}
            onClick={this.changeRedemptionMode(UNITS)}
          />
          <Debtbutton
            buttontitle="Amount"
            width={150}
            disabled={redemptionType === FULL ? true : false}
            active={redemptionMode === AMOUNT}
            onClick={this.changeRedemptionMode(AMOUNT)}
          />
        </div>

        <div className="input-margin">
          <Input
            name="Redemption Value (Amount/UNITS)"
            onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === "." || evt.key === "-") &&
              evt.preventDefault()
            }
            bordercolor="#a6a6a6"
            errorMessage={amount.errorMessage}
            isShowError={amount.isError}
            type="number"
            onBlur={this.showError("amount")}
            disabled={redemptionType === FULL ? true : false}
            inputref={(ele) => (this.amountField = ele)}
            onChange={(event) => this.handleRedemptionValueChange(event)}
            value={amount.value}
          />
        </div>

        <div className="input-margin">
          <CustomizedSelect
            placeholder="Select Bank"
            name="Bank"
            isError={bank.isError}
            errorMessage={bank.errorMessage}
            handleChange={this.handlefolioBankDetailsChange}
            value={bank.value}
            borderColor="#a6a6a6"
            disabled={!folio.value}
            inputRef={(ele) => (this.bankField = ele)}
          >
            {banks.map((item, index) => (
              <MenuItem value={item} key={index}>
                {item.bnkname}-{item.bnkacno}
              </MenuItem>
            ))}
          </CustomizedSelect>
          {/* {!!bank.errorMessage ? <div>{bank.errorMessage}</div> : ""} */}
        </div>
        <div className="digital-form-button-next-div">
          <Signbutton buttontitle="Submit" onClick={this.submit} />
        </div>
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
    } = authReducer;
    const { transactionDetails } = transactions;

    return {
      fundList,
      token,
      userId,
      bankDetails,
      investorData,
      communicationDetails,
      transactionDetails,
    };
  },
  { getBankDetails, getRedemptionPaymentDetails, saveTransactionDetails }
)(Redemption);
